export default "<p>\r\n  t-hash works!\r\n</p>\r\n"